export type ContractExpiration = "upcoming" | "recently_expired";

export const expirationOptions: { value: ContractExpiration; label: string }[] = [
  { value: "upcoming", label: "Próximos da expiração" },
  { value: "recently_expired", label: "Expirados recentemente" },
];

export const readContractExpiration = (value: string | null): ContractExpiration | "" =>
  value === "upcoming" || value === "recently_expired" ? value : "";

export const contractExpirationLink = (expiration: ContractExpiration, franchiseId?: string, contractId?: string) => {
  const query = new URLSearchParams({ expiration });
  if (franchiseId !== undefined) query.set("franchise_id", franchiseId);
  if (contractId) query.set("contractId", contractId);
  return `/documents-electronic?${query.toString()}`;
};
